import HandWaveEmoji from './assets/svgs/emoji-wave.svg';
import './assets/styles/greeting.scss';

const Greeting = () => {
  return (
    <div className="greeting">Welcome back <img src={HandWaveEmoji} alt="hi"/></div>
  )
}

export default Greeting;